/* eslint-disable */
import { waitForElm } from 'utils/helpers';

const initKustomer = () => {

  const windowWidth = window.innerWidth;
  const iconSize = windowWidth < 768 ? 40 : 60;
  
  const checkURLparams = function () {
    const urlParams = new URLSearchParams(window.location.search);
    const chatUrlParam = urlParams.get('chat');
    if (chatUrlParam == 'open') {
      Kustomer.open();
    }
  };

  const createConversation = function() {
    Kustomer.createConversation();
  }

  const addListeners = function () {
    Kustomer.addListener('onOpen', createConversation);
  }

  const addCss = function () {
    var iframe = document.getElementById('kustomer-ui-sdk-iframe');
    const customStyles = window.kustomerCustomStyle;

            const styleElement = document.createElement('style');
            styleElement.type = 'text/css';
            styleElement.appendChild(document.createTextNode(customStyles));

            const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
            iframeDoc.head.appendChild(styleElement);
  }

  Kustomer.start(
    {
      brandId: window.kustomerBrandId,
      chatIconSize: { height:iconSize, width:iconSize }
    },
    function () {
      checkURLparams();
      addListeners();
      if(window.kustomerCustomStyle.length > 0){
        addCss();
      }      
    },
  );
};
waitForElm(
  `script[src="https://cdn.kustomerapp.com/chat-web/widget.js"]`,
  document.head,
).then((element) => {
  if (window.Kustomer) {
    initKustomer();
  } else {
    element.addEventListener('load', () => {
      initKustomer();
    });
  }
});
